var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Falta una tabla en la camaaaa\n    "),_c('v-btn',{staticClass:"ma-2 btnBuscar elevation-2",attrs:{"tile":"","outlined":"","color":"indigo"},on:{"click":function($event){return _vm.enviarMensaje()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-magnify")]),_vm._v(" enviar mensaje\n\t")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36db7392","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Gestion/gestionRehabilitacion/tabla/tabla.html
// module id = 1099
// module chunks = 0